import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { Container } from 'reactstrap'
import NavBar from './NavBar'
import Cookies from 'universal-cookie'
import { push } from 'connected-react-router'
import { checkAdminToken } from '../../../actions/adminActions'
const cookies = new Cookies()

class AdminLayout extends Component {
  componentWillMount () {
    console.log(this.props.token)
    // If there is no auth property, lets fetch
    if (!this.props.auth || !this.props.token) {
      // if there is a token or param lets get the auth details
      if (this.props.match.params.accessToken) {
        this.props.checkAdminToken(this.props.match.params.accessToken)
        return
      } else if (cookies.get('ps_admin_access_token')) {
        this.props.checkAdminToken(cookies.get('ps_admin_access_token'))
        return
      }
      // otherwise redirect to login page
      this.props.loginPage()
    }
  }

  render () {
    if (this.props.token) {
      return (
        <main className='admin'>
          <NavBar />
          <Container>
            {this.props.children}
          </Container>
        </main>
      )
    }
    return null
  }
}

AdminLayout.propTypes = {
  children: PropTypes.node,
  loginPage: PropTypes.func,
  checkAdminToken: PropTypes.func,
  match: PropTypes.object,
  auth: PropTypes.object,
  token: PropTypes.string
}

const mapStateToProps = ({ auth, admin }) => ({
  auth,
  token: admin.token
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loginPage: () => push('/admin/login'),
      checkAdminToken
    },
    dispatch)

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminLayout))



// WEBPACK FOOTER //
// ./src/containers/admin/AdminLayout/AdminLayout.jsx